import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ breakpoints, spacing }) => ({
  root: ({ variant }) => ({
    ...(variant === 'vertical' && {
      flexDirection: 'column',
      alignItems: 'flex-start'
    })
  }),
  lang: ({ variant }) => ({
    padding: spacing(1.5),
    flex: '0 0 auto',
    ...(variant === 'floating' && {
      [breakpoints.down('sm')]: {
        flex: '1 0 auto',
        justifyContent: 'flex-end'
      }
    })
  }),
  translateIcon: {
    // Makes the icon's size the same as the other toolbar icons.
    '& .MuiButton-iconSizeLarge': {
      '& > *:first-child': {
        fontSize: '1.5rem'
      }
    }
  }
}))
